export class ComponentProjectUpdate {
  id: number;
  projectId: number;
  notesId: number;
  enteredAt: Date;
  enteredBy: string;
  noteContent: string;
}
